import { get, put, post, deleteRequest } from 'utils/api';
import { createAsyncThunk } from '@reduxjs/toolkit';

import TYPES from './types';

export const createEventType = createAsyncThunk(
  TYPES.CREATE_EVENT_TYPE,
  async (params, { rejectWithValue }) => {
    try {
      const res = await post('/enums/event-types', params);

      return res?.data;
    } catch (e) {
      return rejectWithValue(e);
    }
  }
);

export const updateEventType = createAsyncThunk(
  TYPES.UPDATE_EVENT_TYPE,
  async (params, { rejectWithValue }) => {
    try {
      const { event_type_id, ...rest } = params;

      const res = await put(`/enums/event-types/${event_type_id}`, { ...rest });

      return res?.data;
    } catch (e) {
      return rejectWithValue(e);
    }
  }
);

export const deleteEventType = createAsyncThunk(
  TYPES.DELETE_EVENT_TYPE,
  async (params, { rejectWithValue }) => {
    try {
      const { event_type_id } = params;

      const res = await deleteRequest(`/enums/event-types/${event_type_id}`);

      return res?.data;
    } catch (e) {
      return rejectWithValue(e);
    }
  }
);

export const getEventTypesVisibility = createAsyncThunk(
  TYPES.GET_EVENT_TYPES_VISIBILITY,
  async (params, { rejectWithValue }) => {
    try {
      const { event_type_id } = params;

      const res = await get(`/enums/event-types/${event_type_id}/visibility`);

      return res?.data;
    } catch (e) {
      return rejectWithValue(e);
    }
  }
);

export const updateEventTypesVisibility = createAsyncThunk(
  TYPES.UPDATE_EVENT_TYPES_VISIBILITY,
  async (params, { rejectWithValue }) => {
    try {
      const { event_type_id, ...rest } = params;

      const res = await put(`/enums/event-types/${event_type_id}/visibility`, { ...rest });

      return res?.data;
    } catch (e) {
      return rejectWithValue(e);
    }
  }
);
